import { DEFAULT_LANG, appName } from "../constants/constants";
import { isProdEnviremonet } from "../helpers/node";

export const getUrlVars = () => {
  let vars = [],
    hash;
  let hashes = window.location.href
    .slice(window.location.href.indexOf("?") + 1)
    .split("&");
  for (let i = 0; i < hashes.length; i++) {
    hash = hashes[i].split("=");
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
};

/**
 * return false only if a URL param "layout" exists and it's value is "false";
 */
export const getLayoutFromUrl = () => {
  let params = getUrlVars();
  return !(params.layout && params.layout.toLowerCase() == "false");
};

export const getLangFromUrl = () => {
  let params = getUrlVars();
  if (params.lang) return params.lang.toLowerCase();
  else return DEFAULT_LANG;
};

export const getLocale = () => {
  if (navigator.languages != undefined) return navigator.languages[0];
  else return navigator.language;
};

/**
 * returns the full appliaction url (no domain) up to the appName, includes the subfolders.
 * the appName is a convention with the server's controller / API method.
 */
export const getBaseUrl = (appName = "", includeAppName = false) => {
  const pathName = window.location.pathname.toLowerCase();
  const appNameIndex = pathName.indexOf(appName.toLowerCase());
  const appNameUrlLength =
    appNameIndex > -1 && includeAppName ? appName.length : -1; // remove lst slash (-1)
  //const startIndex = appName ? 1 : 0;
  const result = pathName.substring(0, appNameIndex + appNameUrlLength);
  return result;
};

/**
 * returns the api name relevant to the current application name.
 * the appName is a convention with the server's controller / API method.
 */
export const getFullApiName = (appName, apiName) => {
  let result = apiName;
  let fullAppName = getBaseUrl(appName);
  if (fullAppName && fullAppName.length > 0) {
    result = fullAppName.replace(appName, apiName);
  }

  return result;
};

export const serverURL = isProdEnviremonet
  ? getBaseUrl(appName)
  : `//localhost:8888`;



// WEBPACK FOOTER //
// ./src/helpers/url-helpers.js